// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2SEoN","content":"LayoutSettings_content__3X4jE"};